import contactUs from '../../flow/customer/contactUs';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';

export const contactUsAtomFn = RuntimeClientAtom.fn(contactUs);
